import { render } from "./InvestingWizard.vue?vue&type=template&id=fd6d0718"
import script from "./InvestingWizard.vue?vue&type=script&lang=js"
export * from "./InvestingWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__